<style scoped>
.padding-10 {
  padding: 10px;
}
</style>
<template>

<div class="padding-10">
  <div>
    <ModelItem :media="channel.thumbnailDefault" :controllable="false" v-if="channel.hasOwnProperty('thumbnailDefault') && isModelType(channel.thumbnailDefault.type)" />
    <div class="full-width channel-thumbnail" v-else>
      <img class="full-width" :src="thumbnailSource">
    </div>
    <div class="display-flex">
      <div class="flex-item">
        <div class="item-title flex-item channel-title">{{channel.name}}</div>
        <div v-if="isDetailShow">
          <span v-for="(item, index) in channel.media_count" :key="index">
            <span v-if="item !== 0">
              <mu-icon :value="stringType(index)" class="vertical-align-bottom"></mu-icon> {{item}}
            </span>
          </span>
          <span v-if="this.channel.playlist !== 0">
            <mu-icon value="playlist_play" class="vertical-align-bottom"></mu-icon>{{channel.playlist}}
          </span>
        </div>
      </div>
      <BookmarkButton 
        :id="channel._id"
        type="channel"
        :object="channel"
        />
      <mu-menu cover v-if="(isOwner || isAdmin) && !isPreview" :open.sync="open">
        <mu-button icon @click.stop.prevent="open = true">
          <mu-icon value="more_vert"></mu-icon>
        </mu-button>
        <mu-list slot="content">
          <mu-list-item button @click.stop.prevent="flagDialogEdit = true">
            <mu-list-item-action>
              <mu-icon value="edit"></mu-icon>
            </mu-list-item-action>
            <mu-list-item-title>{{$t('button.edit')}}</mu-list-item-title>
          </mu-list-item>
          <mu-list-item button @click.stop.prevent="flagDialogThumbnail = true">
            <mu-list-item-action>
              <mu-icon value="image"></mu-icon>
            </mu-list-item-action>
            <mu-list-item-title>{{$t('ChannelCard.thumbnail.display')}}</mu-list-item-title>
          </mu-list-item>
          <mu-list-item button @click.stop.prevent="onClickEnrollment" v-if="isCourseChannel && !isPublicChannel">
            <mu-list-item-action>
              <mu-icon value="people"></mu-icon>
            </mu-list-item-action>
            <mu-list-item-title>{{$t('terms.enrollment')}}</mu-list-item-title>
          </mu-list-item>
          <mu-list-item button @click.stop.prevent="onClickManager" v-if="isCourseChannel">
            <mu-list-item-action>
              <mu-icon value="record_voice_over"></mu-icon>
            </mu-list-item-action>
            <mu-list-item-title>{{$t('terms.admin')}}</mu-list-item-title>
          </mu-list-item>
          <mu-list-item button @click.stop.prevent="onClickDelete">
            <mu-list-item-action>
              <mu-icon value="delete"></mu-icon>
            </mu-list-item-action>
            <mu-list-item-title>{{$t('button.delete')}}</mu-list-item-title>
          </mu-list-item>
          <mu-list-item button @click.stop.prevent="onClickClone">
            <mu-list-item-action>
              <mu-icon value="file_copy"></mu-icon>
            </mu-list-item-action>
            <mu-list-item-title>{{$t('button.clone')}}</mu-list-item-title>
          </mu-list-item>
        </mu-list>
      </mu-menu>
      <div v-if="isProgressShow && flagProgressFetched && isPreview" class="padding-10 text-align-right">
        <loading-progress
          :progress="progress"
          shape="line"
          size="80"
          width="80"
          height="10"
          />
        <div>{{ $t('ChannelCard.completed') + ' ' + progressPercentage }}%</div>
        <div v-if="isQuestionProgressShow">
          <loading-progress
            :progress="questionProgress"
            shape="line"
            size="80"
            width="80"
            height="10"
            />
          <div>{{ $t('ChannelCard.quiz_completed') + ' ' + questionPercentage }}%</div>
        </div>
      </div>
    </div>
  </div>
  <mu-dialog :title="$t('button.edit') + $t('space') + $t('ChannelCard.title')" scrollable max-width="100%" :esc-press-close="false" :overlay-close="false" :open.sync="flagDialogEdit">
    <mu-form :model="channel" label-width="500">
      <mu-form-item prop="input" :label="$t('ChannelCard.' + channel.type) + $t('space') + $t('prompt.name')">
        <mu-text-field v-model="modelName"></mu-text-field>
      </mu-form-item>
      <mu-form-item prop="input" :label="$t('ChannelCard.alias')">
        <mu-text-field v-model="modelAlias"></mu-text-field>
      </mu-form-item>
      <mu-form-item prop="input" :label="$t('ChannelCard.public')">
        <mu-radio v-model="modelPublic" :value="false" :label="$t('radio.no')"></mu-radio>
        <mu-radio v-model="modelPublic" :value="true" :label="$t('radio.yes')"></mu-radio>
      </mu-form-item>
    </mu-form>
    <mu-button slot="actions" flat color="primary" @click="onActionCancel"><mu-icon value="close"></mu-icon> {{$t('prompt.cancel')}}</mu-button>
    <mu-button slot="actions" flat color="primary" @click="onActionEdit" :disabled="isNameEmpty"><mu-icon value="check"></mu-icon> {{$t('prompt.confirm')}}</mu-button>
  </mu-dialog>

  <mu-dialog :title="$t('button.clone') + $t('space') + $t('ChannelCard.title')" scrollable max-width="100%" :esc-press-close="false" :overlay-close="false" :open.sync="flagDialogClone">
    <small>{{$t('ChannelCard.cloneDescription')}}</small>
    <mu-button slot="actions" flat color="primary" @click="onActionCancelClone"><mu-icon value="close"></mu-icon> {{$t('prompt.cancel')}}</mu-button>
    <mu-button slot="actions" flat color="primary" @click="onActionClone"><mu-icon value="check"></mu-icon> {{$t('prompt.confirm')}}</mu-button>
  </mu-dialog>

  <mu-dialog :title="$t('button.edit') + $t('space') + $t('ChannelCard.thumbnail.display')" scrollable max-width="100%" :esc-press-close="false" :overlay-close="false" :open.sync="flagDialogThumbnail">
    <mu-checkbox v-model="channel.thumbnail" :label="$t('ChannelCard.thumbnail.use')"></mu-checkbox>
    <div v-if="channel.thumbnail">
      <br />
      <input type="file" id="file" ref="thumbnail" @change="onFileChangeThumbnail" />
    </div>
    <mu-button slot="actions" flat color="primary" @click="flagDialogThumbnail = false"><mu-icon value="close"></mu-icon> {{$t('prompt.cancel')}}</mu-button>
    <mu-button slot="actions" flat color="primary" @click="onActionThumbnail"><mu-icon value="check"></mu-icon> {{$t('prompt.confirm')}}</mu-button>
  </mu-dialog>

  <mu-dialog :title="$t('button.delete') + $t('space') + $t('ChannelCard.title')" scrollable max-width="100%" :esc-press-close="false" :overlay-close="false" :open.sync="flagDialogDelete">
    {{stringDelete}}
    <mu-button slot="actions" flat color="primary" @click="flagDialogDelete = false"><mu-icon value="close"></mu-icon> {{$t('prompt.cancel')}}</mu-button>
    <mu-button slot="actions" flat color="primary" @click="onActionDelete"><mu-icon value="check"></mu-icon> {{$t('prompt.confirm')}}</mu-button>
  </mu-dialog>
</div>

</template>

<script>
// Components
import ModelItem from '@/components/Media/Content/ModelItem.vue'

import BookmarkButton from '@/components/Bookmark/Button'

// Library
import axios from "axios";

import langEn from './lang/en.json'
import langZh from './lang/zh.json'

export default {
  name: 'ChannelCard',
  components: {
    ModelItem,
    BookmarkButton,
  },
  props: {
    channel: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      // Object
      completion: {},
      
      // Flag
      flagDialogEdit: false, // Boolean variable for status of edit dialog
      flagDialogDelete: false, // Boolean variable for status of delete dialog
      flagDialogClone: false,
      flagDialogThumbnail: false,
      flagAdmin: false,
      flagProgressFetched: false,

      // Model
      modelName: this.channel.name,
      modelAlias: this.channel.alias,
      modelThumbnail: this.channel.thumbnail ? this.channel.thumbnail : false,
      modelPublic: this.channel.public ? this.channel.public : false,

      interval: null,
      timeout: null,
      
      open: false,
    }
  },
  computed: {
    // Flag
    isOwner() {
      if (this.channel.creator_id === this.$store.state.auth.user._id) {
        return true;
      } else {
        return false;
      }
    },
    isNameEmpty() {
      if (this.modelName === "") {
        return true;
      } else {
        return false;
      }
    },
    isTeacher() {
      return this.$store.getters.isTeacher;
    },
    isAdmin() {
      return this.$store.getters.isAdmin || this.flagAdmin;
    },
    isCourseChannel() {
      return this.channel.type === "course";
    },
    isPublicChannel() {
      return this.channel.hasOwnProperty('public') && this.channel.public === true;
    },
    isDetailShow() {
      var flag = false;
      Object.keys(this.channel.media_count).forEach(key => {
        if(this.channel.media_count[key] === 0) {
          flag = flag || true;
        }
      });
      return this.channel.playlist !== 0 || flag;
    },
    isProgressShow() {
      if(this.completion.mediaTotal === 0) {
        return false;
      } else {
        return true;
      }
    },
    isQuestionProgressShow() {
      return this.completion.questionTotal > 0;
    },
    isPreview() {
      if(this.$store.getters.previewMode) {
        return true;
      } else {
        return false;
      }
    },

    // string
    stringDelete() {
      return this.$t('prompt.deleteMsg', { name: this.channel.name });
    },
    thumbnailSource() {
      if(this.channel.thumbnail) {
        return this.$store.getters.urlStorage + 'thumbnails/' + this.channel._id + '.' + this.channel.thumbnailType;
      } else if(this.channel.thumbnailDefault) {
        if(this.channel.thumbnailDefault.type == "youtube" && !this.channel.thumbnailDefault.thumbnail.includes('999.png')) {
          return this.stringThumbnailYoutube(this.channel.thumbnailDefault);
        } else if(this.channel.thumbnailDefault.type == "img") {
          return this.channel.thumbnailDefault.content;
        } else {
          return this.channel.thumbnailDefault.thumbnail;
        }
      } else {
        return this.channelDefault;
      }
    },

    // Progress
    progress() {
      return this.completion.mediaCompletion / this.completion.mediaTotal;
    },
    progressPercentage() {
      return Math.round(this.progress * 100);
    },
    questionProgress() {
      return this.completion.questionCompletion / this.completion.questionTotal;
    },
    questionPercentage() {
      return Math.round(this.questionProgress * 100);
    },

  },
  mounted() {
    this.fetchAdmin();
    this.fetchCompletion();
  },
  created() {
    this.$i18n.add('en', langEn); // Add English Translation
    this.$i18n.add('zh', langZh); // Add Traditional Chinese Translation
  },
  methods: {
    // Fetch
    fetchAdmin() {
      axios.get(this.$store.getters.urlApi + "admin/channel/" + this.channel._id, {
        headers: {
          token: this.$store.state.auth.token
        }
      }).then(response => {
        this.flagAdmin = response.data.data.admin.user_ids.includes(this.$store.state.auth.user._id);
      });
    },
    fetchCompletion() {
      if(!this.isAdmin) {
        axios.get(this.$store.getters.urlApi + "channel/" + this.channel._id + "/completion", {
          headers: {
            token: this.$store.state.auth.token
          }
        }).then(response => {
          this.completion = response.data.data.completion;
          this.flagProgressFetched = true;
        });
      }
    },

    // Event
    onActionCancel() {
      this.flagDialogEdit = false;
      this.modelName = this.channel.name;
    },
    onActionEdit() {
      this.flagDialogEdit = false;
      axios.put(this.$store.getters.urlApi + "channel/" + this.channel._id, {
        'name': this.modelName,
        'alias': this.modelAlias,
        'public': this.modelPublic
      }, {
        headers: {
          token: this.$store.state.auth.token,
          'content-type': 'application/json'
        },
      }).then(() => {
        this.$store.commit("triggerRefresh");
        this.$toast.success(this.$t('toast.edit'));
      });
    },
    onClickDelete() {
      this.flagDialogDelete = true;
    },
    onClickClone() {
      this.flagDialogClone = true;
    },
    onActionDelete() {
      this.flagDialogDelete = false;
      axios.delete(this.$store.getters.urlApi + "channel/" + this.channel._id, {
        headers: {
          token: this.$store.state.auth.token
        },
      }).then(() => {
        this.$store.commit("triggerRefresh");
        this.$toast.success(this.$t('toast.delete'));
      });
    },
    onClickEnrollment() {
      this.$router.push({
        name: 'Enrollment',
        params: {
          channelId: this.channel._id
        }
      });
    },
    onClickManager() {
      this.$router.push({
        name: 'Manager',
        params: {
          channelId: this.channel._id
        }
      });
    },
    onActionCancelClone() {
      this.flagDialogClone = false;
    },
    onActionClone() {
      this.flagDialogClone = false;
      axios.post(this.$store.getters.urlApi + "channel/" + this.channel._id, {}, {
        headers: {
          token: this.$store.state.auth.token,
          'content-type': 'application/json'
        },
      }).then(() => {
        this.$store.commit("triggerRefresh");
        this.$toast.success(this.$t('toast.clone'));
      });
    },
    onActionThumbnail() {
      this.flagDialogThumbnail = false;
      let formData = new FormData();
      formData.append('_method', "PUT");
      if(this.channel.thumbnail) {
        formData.append('file', this.modelFile);
      }
      axios.post(this.$store.getters.urlApi + "channel/" + this.channel._id + "/thumbnail", formData, {
        headers: {
          token: this.$store.state.auth.token
        },
        }
      ).then(res => {
        this.$store.commit("triggerRefresh");
        this.$toast.success(this.$t('toast.edit'));
      });
    },
    onFileChangeThumbnail() {
      if (this.$refs.thumbnail.files[0] != undefined) {
        this.modelFile = this.$refs.thumbnail.files[0];
      } else {
        this.modelFile = null;
      }
    },

    // Flag
    isModelType(type) {
      var array = ["stl", "obj", "three", "collada", "ply", "gltf"];
      return array.includes(type);
    },

    // String
    stringType(type) {
      if(type == "video") {
        return 'movie';
      } else if(type == "img") {
        return "photo";
      } else if(type == "pdf") {
        return "insert_drive_file";
      } else if(type == "youtube") {
        return 'subscriptions';
      } else if(type == "wysiwyg") {
        return "text_format";
      } else if(type == "mp4link") {
        return "on_demand_video";
      } else if(this.isModelType(type) || type == 'model') {
        return 'layers';
      }
    },
    stringThumbnailYoutube(data) {
      return "//img.youtube.com/vi/" + data.content + "/" + data.thumbnail + ".jpg"
    },
  },
}
</script>
